import React from "react";
import styled from "styled-components";

export default function LandingAbout({
  tag = "About",
  title = "IVF JABALPUR FERTILITY CENTRE",
  imgUrl = "/images/about/about_doctor.png",
  description1 = "We combine cutting-edge IVF technology with compassionate care to help you achieve your dream of parenthood. Our dedicated team of specialists works tirelessly to provide you with the best possible outcomes in a supportive environment.",
  description2 = "With years of experience and a commitment to excellence, we have brought smiles to thousands of families. Your journey to parenthood is our priority.",
  stats = [
    { num: "15+", label: "Years Experience" },
    { num: "90%", label: "Success Rate" },
    { num: "5000+", label: "Happy Families" },
    { num: "50+", label: "Expert Doctors" },
  ],
}) {
  return (
    <AboutWrapper>
      <div className="container">
        <div className="landing_about_grid">
          <div className="landing_about_img_box">
            <img src={imgUrl} alt={title} className="landing_about_img" />
          </div>
          <div className="landing_about_text_box">
            <span className="landing_about_tag">{tag}</span>
            <h2 className="landing_about_title">{title}</h2>
            <p className="landing_about_desc">{description1}</p>
            <p className="landing_about_desc">{description2}</p>
          </div>
        </div>

        {stats && stats.length > 0 && (
          <div className="landing_about_stats">
            {stats.map((item, index) => (
              <div className="stat_badge" key={index}>
                <span className="stat_num">{item.num}</span>
                <span className="stat_label">{item.label}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </AboutWrapper>
  );
}

const AboutWrapper = styled.section`
  padding: 70px 0 80px 0;
  background-color: #ffffff;

  .landing_about_grid {
    display: grid;
    grid-template-columns: 1fr 1.15fr;
    gap: 50px;
    align-items: center;
  }

  .landing_about_img_box {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .landing_about_img {
    width: 100%;
    max-width: 480px;
    border-radius: 22px;
    box-shadow: 0 12px 35px rgba(0, 0, 0, 0.08);
    display: block;
    object-fit: cover;
  }

  .landing_about_text_box {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .landing_about_tag {
    color: #ea7a1e;
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 8px;
    display: block;
    letter-spacing: 0.2px;
  }

  .landing_about_title {
    color: #1a2238;
    font-size: 34px;
    font-weight: 800;
    line-height: 1.25;
    margin-bottom: 22px;
    text-transform: uppercase;
    letter-spacing: -0.3px;
  }

  .landing_about_desc {
    color: #596579;
    font-size: 15.5px;
    line-height: 1.75;
    margin-bottom: 18px;

    &:last-of-type {
      margin-bottom: 0;
    }
  }

  .landing_about_stats {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
    flex-wrap: wrap;
    margin-top: 55px;
  }

  .stat_badge {
    background: #ea7a1e;
    color: #ffffff;
    padding: 13px 28px;
    border-radius: 50px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    box-shadow: 0 6px 18px rgba(234, 122, 30, 0.28);
    transition: all 0.3s ease;
    cursor: default;

    &:hover {
      transform: translateY(-3px);
      box-shadow: 0 8px 22px rgba(234, 122, 30, 0.4);
    }
  }

  .stat_num {
    font-size: 17px;
    font-weight: 800;
    white-space: nowrap;
  }

  .stat_label {
    font-size: 14.5px;
    font-weight: 500;
    white-space: nowrap;
    opacity: 0.96;
  }

  /* Tablets */
  @media (max-width: 991px) {
    padding: 55px 0 65px 0;

    .landing_about_grid {
      grid-template-columns: 1fr;
      gap: 35px;
    }

    .landing_about_img {
      max-width: 440px;
      margin: 0 auto;
    }

    .landing_about_title {
      font-size: 30px;
      margin-bottom: 18px;
    }

    .landing_about_stats {
      margin-top: 40px;
      gap: 16px;
    }
  }

  /* Mobile */
  @media (max-width: 767px) {
    padding: 45px 0 55px 0;

    .landing_about_title {
      font-size: 26px;
      line-height: 1.3;
    }

    .landing_about_desc {
      font-size: 14.5px;
      line-height: 1.65;
    }

    .landing_about_stats {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 12px;
      margin-top: 35px;
    }

    .stat_badge {
      padding: 10px 14px;
      gap: 5px;
      flex-direction: column;
      text-align: center;
      border-radius: 20px;
    }

    .stat_num {
      font-size: 16px;
    }

    .stat_label {
      font-size: 12.5px;
      white-space: normal;
    }
  }

  @media (max-width: 420px) {
    .landing_about_stats {
      grid-template-columns: 1fr;
    }

    .stat_badge {
      flex-direction: row;
      border-radius: 50px;
      padding: 11px 20px;
    }
  }
`;
